import templateUrl from './groupSectionHeader.html';

export default {
  controllerAs: 'ctrl',
  controller: class {
    constructor(Authentication, SubscriptionUtils) {
      'ngInject';

      Object.assign(this, { Authentication, SubscriptionUtils });
    }

    $onInit() {
      this.planName = this.SubscriptionUtils.getSubscriptionName(
        this.Authentication.user.orgSettings.premiumFeatures[this.premiumFeature]
      );
    }
  },
  templateUrl,
  bindings: {
    isPremium: '<',
    title: '@',
    noMargin: '<?',
    premiumFeature: '@',
    underline: '<?',
  },
};
